module.exports = __webpack_public_path__ + "62bc91a2c7e18cd2de94753bf72774b7.png";